import { Fragment, type ReactNode } from 'react'
import { TabGroup } from '@headlessui/react'
import { twMerge } from 'tailwind-merge'

interface PageTabGroupProps extends Record<string, unknown> {
  className?: string
}

export const PageTabGroup = ({ className, ...props }: PageTabGroupProps): ReactNode => {
  return (
    <div className={twMerge('w-full', className)}>
      <TabGroup as={Fragment} {...props} />
    </div>
  )
}
